module.exports = __webpack_public_path__ + "static/media/arrietty.6f922788.jpg";